
<template>
  <div class="search" :class="{ isIosx: isIosx, noAppNav: !isToken }">
    <div class="searchNav" id="searchNav">
      <img
        class="navLeft"
        @click="prev()"
        src="./../../assets/school/backh.png"
      />
      <div class="navMid">
        <img src="./../../assets/school/seach1.png" alt="" />
        <van-field
          v-model="title"
          :border="false"
          :clearable="true"
          :placeholder="
            hotWordList.length > 0
              ? hotWordList[0].title
              : '请输入想要搜索的课程'
          "
          @focus="getFocus()"
        />
      </div>
      <span class="navRight" @click="toSearch()">搜索</span>
    </div>
    <div class="searchContent">
      <!-- 最近搜索 -->
      <div class="contentOut" v-if="isToken">
        <h3>
          最近搜索
          <img
            src="./../../assets/school/del.png"
            @click="del()"
            v-if="historyList.length > 0 && isToken"
          />
        </h3>
        <div class="contentIn">
          <span
            v-for="(item, index) in historyList"
            :key="index"
            @click="itemSearch(item.word)"
            >{{
              item.word.length > 16 ? item.word.slice(0, 16) + "..." : item.word
            }}</span
          >
        </div>
      </div>
      <!-- 热门搜索 -->
      <div class="contentOut" v-if="hotWordList.length > 0">
        <h3>热门搜索</h3>
        <div class="contentIn">
          <span
            v-for="(item, index) in hotWordList"
            :key="index"
            @click="itemSearch(item.title)"
            >{{
              item.title.length > 16
                ? item.title.slice(0, 16) + "..."
                : item.title
            }}</span
          >
        </div>
      </div>
    </div>
    <!-- 蒙层 -->
    <div class="overlay"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isIosx: false,
      title: "",
      historyList: [],
      hotWordList: [],
      isToken: false,
    };
  },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.isToken = true;
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.getHistoryData();
    } else {
      this.isToken = false;
    }
    if (this.$route.query.hotWordList) {
      this.hotWordList = JSON.parse(this.$route.query.hotWordList);
    }
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    // 获取历史记录
    getHistoryData() {
      this.$api.get("school/member/search/words").then((res) => {
        this.historyList = res.list;
      });
    },
    // 获得焦点
    getFocus() {
      if (this.isToken) {
        this.getHistoryData();
      }
    },
    // 搜索课程
    toSearch() {
      this.$router.push({
        path: "/school/searchResult",
        query: {
          searchTitle:
            this.hotWordList.length > 0 && this.title == ""
              ? this.hotWordList[0].title
              : this.title,
        },
      });
    },
    itemSearch(title) {
      this.title = title;
      this.toSearch();
    },
    // 删除历史记录
    del() {
      let ids = [];
      this.historyList.forEach((item) => {
        ids.push(item.id);
      });
      this.$dialog
        .confirm({
          title: "确认删除",
          message: "确认删除全部历史记录？",
          width: "280px",
          confirmButtonColor: "#4E7DF7",
          cancelButtonColor: "#EDF2FE",
          theme: "round-button",
        })
        .then(() => {
          this.$api
            .post("school/member/search/words/delete", {
              ids: ids,
            })
            .then((res) => {
              this.$toast("删除成功！");
              this.getHistoryData();
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style>
.search {
  height: 100%;
  position: relative;
}
.searchNav {
  color: #404247;
  height: 22px;
  padding-top: 44px;
  padding-bottom: 11px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
}
.searchNav .navLeft {
  width: 24px;
  height: 24px;
  margin-left: 16px;
}
.searchNav .navMid {
  flex: 1;
  height: 33px;
  background: #f7f8fc;
  border-radius: 16px;
  margin: 0 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.searchNav .navMid img {
  width: 16px;
  height: 16px;
  margin-left: 16px;
}
.searchNav .navMid input {
  height: 33px;
}
.searchNav .navMid .van-cell {
  height: 33px;
  flex: 1;
  padding: 0;
  margin: 0 10px;
  background-color: #f7f8fc;
}
.searchNav .navRight {
  color: #6e727a;
  margin-right: 16px;
}
/* content */
.searchContent {
  background-color: #ffffff;
  padding: 0 0px 64px;
  position: absolute;
  width: 100%;
  top: 77px;
  left: 0;
  z-index: 2;
}
.searchContent .contentOut {
  padding-top: 24px;
  margin: 0 16px;
}
.searchContent h3 {
  margin: 0;
  color: #333333;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.searchContent h3 img {
  width: 16px;
  height: 16px;
}
.searchContent .contentIn {
  display: flex;
  flex-wrap: wrap;
}
.searchContent .contentIn span {
  display: inline-block;
  padding: 7px 16px;
  background-color: #f7f8fc;
  border-radius: 16px;
  margin-right: 12px;
  margin-top: 12px;
  color: #6e727a;
  font-size: 13px;
}
/* 蒙层 */
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
}

/* 弹窗 */
.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel{
  color: #4E7DF7 !important;
}

.isIosx .searchNav {
  padding-top: 49px;
}

.noAppNav .searchNav{
  padding-top: 15px !important;
}
.noAppNav .searchContent{
  top: 48px;
}
</style>